import React, { FC } from 'react';
import { scale as initialScale } from '@components/frame';
import { font as initialFont } from '@styles/fonts';
import OperatorPanelButton from '@components/operatorPanel/components/elements/buttons/OperatorPanelButton';
import LoadableActionButton from '@components/operatorPanel/components/elements/buttons/LoadableActionButton';
import { PanelProps } from '@components/operatorPanel/components/panel';

export interface LinkToJobButtonProps extends Pick<PanelProps, 'CC' | 'scale' | 'font'> {
  onPress: (onActionStart: () => void) => void;
}

const LinkToJobButton: FC<LinkToJobButtonProps> = ({ onPress, CC, scale = initialScale, font = initialFont }) => (
  <LoadableActionButton onPress={onPress} CC={CC} scale={scale}>
    {(handlePress) => (
      <OperatorPanelButton
        onPress={handlePress}
        CC={CC}
        text="Link To Job"
        iconConfig={{ icon: 'linkPlus', height: scale(24), width: scale(20) }}
        textFont="Headline Large Bold"
        textColor="Label/Light/AlwaysDark Primary"
        customButtonBgColor="Label/Light/AlwaysLight Primary"
        buttonContainerStyle={{
          width: scale(336),
          height: scale(120),
          paddingTop: scale(29.5),
          paddingBottom: scale(32.5),
          paddingHorizontal: scale(15),
          gap: scale(12),
          borderRadius: scale(18),
        }}
        iconContainerStyle={{
          marginTop: scale(2),
          marginBottom: scale(2),
        }}
        scale={scale}
        font={font}
      />
    )}
  </LoadableActionButton>
);

export default LinkToJobButton;
